const paises = [
	{
		"code": "AE",
		"name": "United Arab Emirates"
	},
	{
		"code": "BH",
		"name": "Bahrain"
	},
	{
		"code": "DZ",
		"name": "Algeria"
	},
	{
		"code": "EG",
		"name": "Egypt"
	},
	{
		"code": "IQ",
		"name": "Iraq"
	},
	{
		"code": "JO",
		"name": "Jordan"
	},
	{
		"code": "KW",
		"name": "Kuwait"
	},
	{
		"code": "LB",
		"name": "Lebanon"
	},
	{
		"code": "LY",
		"name": "Libya"
	},
	{
		"code": "MA",
		"name": "Morocco"
	},
	{
		"code": "OM",
		"name": "Oman"
	},
	{
		"code": "QA",
		"name": "Qatar"
	},
	{
		"code": "SA",
		"name": "Saudi Arabia"
	},
	{
		"code": "TN",
		"name": "Tunisia"
	},
	{
		"code": "YE",
		"name": "Yemen"
	},
	{
		"code": "AZ",
		"name": "Azerbaijan"
	},
	{
		"code": "BY",
		"name": "Belarus"
	},
	{
		"code": "BG",
		"name": "Bulgaria"
	},
	{
		"code": "BD",
		"name": "Bangladesh"
	},
	{
		"code": "BA",
		"name": "Bosnia and Herzegovina"
	},
	{
		"code": "CZ",
		"name": "Czechia"
	},
	{
		"code": "DK",
		"name": "Denmark"
	},
	{
		"code": "AT",
		"name": "Austria"
	},
	{
		"code": "CH",
		"name": "Switzerland"
	},
	{
		"code": "DE",
		"name": "Germany"
	},
	{
		"code": "GR",
		"name": "Greece"
	},
	{
		"code": "AU",
		"name": "Australia"
	},
	{
		"code": "BE",
		"name": "Belgium"
	},
	{
		"code": "CA",
		"name": "Canada"
	},
	{
		"code": "GB",
		"name": "United Kingdom"
	},
	{
		"code": "GH",
		"name": "Ghana"
	},
	{
		"code": "IE",
		"name": "Ireland"
	},
	{
		"code": "IL",
		"name": "Israel"
	},
	{
		"code": "IN",
		"name": "India"
	},
	{
		"code": "JM",
		"name": "Jamaica"
	},
	{
		"code": "KE",
		"name": "Kenya"
	},
	{
		"code": "MT",
		"name": "Malta"
	},
	{
		"code": "NG",
		"name": "Nigeria"
	},
	{
		"code": "NZ",
		"name": "New Zealand"
	},
	{
		"code": "SG",
		"name": "Singapore"
	},
	{
		"code": "UG",
		"name": "Uganda"
	},
	{
		"code": "US",
		"name": "United States"
	},
	{
		"code": "ZA",
		"name": "South Africa"
	},
	{
		"code": "ZW",
		"name": "Zimbabwe"
	},
	{
		"code": "AR",
		"name": "Argentina"
	},
	{
		"code": "BO",
		"name": "Bolivia"
	},
	{
		"code": "CL",
		"name": "Chile"
	},
	{
		"code": "CO",
		"name": "Colombia"
	},
	{
		"code": "CR",
		"name": "Costa Rica"
	},
	{
		"code": "DO",
		"name": "Dominican Republic"
	},
	{
		"code": "EC",
		"name": "Ecuador"
	},
	{
		"code": "ES",
		"name": "Spain"
	},
	{
		"code": "GT",
		"name": "Guatemala"
	},
	{
		"code": "HN",
		"name": "Honduras"
	},
	{
		"code": "MX",
		"name": "Mexico"
	},
	{
		"code": "NI",
		"name": "Nicaragua"
	},
	{
		"code": "PA",
		"name": "Panama"
	},
	{
		"code": "PE",
		"name": "Peru"
	},
	{
		"code": "PR",
		"name": "Puerto Rico"
	},
	{
		"code": "PY",
		"name": "Paraguay"
	},
	{
		"code": "SV",
		"name": "El Salvador"
	},
	{
		"code": "UY",
		"name": "Uruguay"
	},
	{
		"code": "VE",
		"name": "Venezuela"
	},
	{
		"code": "EE",
		"name": "Estonia"
	},
	{
		"code": "FI",
		"name": "Finland"
	},
	{
		"code": "PH",
		"name": "Philippines"
	},
	{
		"code": "FR",
		"name": "France"
	},
	{
		"code": "SN",
		"name": "Senegal"
	},
	{
		"code": "HR",
		"name": "Croatia"
	},
	{
		"code": "HU",
		"name": "Hungary"
	},
	{
		"code": "ID",
		"name": "Indonesia"
	},
	{
		"code": "IS",
		"name": "Iceland"
	},
	{
		"code": "IT",
		"name": "Italy"
	},
	{
		"code": "JP",
		"name": "Japan"
	},
	{
		"code": "GE",
		"name": "Georgia"
	},
	{
		"code": "KZ",
		"name": "Kazakhstan"
	},
	{
		"code": "KR",
		"name": "South Korea"
	},
	{
		"code": "LU",
		"name": "Luxembourg"
	},
	{
		"code": "LA",
		"name": "Laos"
	},
	{
		"code": "LT",
		"name": "Lithuania"
	},
	{
		"code": "LV",
		"name": "Latvia"
	},
	{
		"code": "MK",
		"name": "North Macedonia"
	},
	{
		"code": "MY",
		"name": "Malaysia"
	},
	{
		"code": "NO",
		"name": "Norway"
	},
	{
		"code": "NP",
		"name": "Nepal"
	},
	{
		"code": "NL",
		"name": "Netherlands"
	},
	{
		"code": "PL",
		"name": "Poland"
	},
	{
		"code": "BR",
		"name": "Brazil"
	},
	{
		"code": "PT",
		"name": "Portugal"
	},
	{
		"code": "MD",
		"name": "Moldova"
	},
	{
		"code": "RO",
		"name": "Romania"
	},
	{
		"code": "RU",
		"name": "Russia"
	},
	{
		"code": "LK",
		"name": "Sri Lanka"
	},
	{
		"code": "SK",
		"name": "Slovakia"
	},
	{
		"code": "SI",
		"name": "Slovenia"
	},
	{
		"code": "ME",
		"name": "Montenegro"
	},
	{
		"code": "RS",
		"name": "Serbia"
	},
	{
		"code": "SE",
		"name": "Sweden"
	},
	{
		"code": "TZ",
		"name": "Tanzania"
	},
	{
		"code": "TH",
		"name": "Thailand"
	},
	{
		"code": "TR",
		"name": "Turkey"
	},
	{
		"code": "UA",
		"name": "Ukraine"
	},
	{
		"code": "PK",
		"name": "Pakistan"
	},
	{
		"code": "VN",
		"name": "Vietnam"
	},
	{
		"code": "HK",
		"name": "Hong Kong"
	},
	{
		"code": "TW",
		"name": "Taiwan"
	},
	{
		"code": "CY",
		"name": "Cyprus"
	},
	{
		"code": "KH",
		"name": "Cambodia"
	},
	{
		"code": "LI",
		"name": "Liechtenstein"
	},
	{
		"code": "PG",
		"name": "Papua New Guinea"
	}
];


export default paises